module.exports = ".table tr.active td {\n    background-color: #007bff69;\n}"